const META_PIXEL_ID = "1946271869683418";

export function initializeMetaPixel() {
  if (typeof window === "undefined") return;
  if (!(window.location.hostname === "kre8content.com" || window.location.hostname === "www.kre8content.com")) return;
  if (window.fbq?.initializedForKre8) return;

  let fbq = window.fbq;
  if (!fbq) {
    fbq = function (...args) {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, args);
      else fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
  }

  fbq("init", META_PIXEL_ID);
  fbq("track", "PageView");
  fbq.initializedForKre8 = true;

  if (!document.getElementById("meta-pixel")) {
    const script = document.createElement("script");
    script.id = "meta-pixel";
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
  }
}

export function trackMetaStartTrial() {
  initializeMetaPixel();
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "StartTrial");
  }
}
